var map = {
	"./filetype-archive.svg": 5356,
	"./filetype-document.svg": 5357,
	"./filetype-excel.svg": 4915,
	"./filetype-image.svg": 5358,
	"./filetype-media.svg": 4916,
	"./filetype-pdf.svg": 4917,
	"./filetype-spreadsheet.svg": 5359,
	"./filetype-unknown.svg": 4918,
	"./filetype-word.svg": 4919,
	"./filetype-zip.svg": 4920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5355;